import { api } from "@/lib/api";

// Status is stable per session; memoise so panels don't each re-request it.
let _statusPromise = null;
export function getIntelStatus() {
  if (!_statusPromise) {
    _statusPromise = api
      .get("/intelligence/status")
      .then((r) => r.data)
      .catch(() => ({ enabled: false, intelligence_version: null }));
  }
  return _statusPromise;
}

export async function fetchScoreExplanation(score_key) {
  const { data } = await api.post("/intelligence/score-explanation", { score_key });
  return data;
}

export async function fetchDomainInsight(domain_key) {
  const { data } = await api.post("/intelligence/domain-insight", { domain_key });
  return data;
}

export async function fetchOpportunityAnalysis(opportunity_id) {
  const { data } = await api.post("/intelligence/opportunity-analysis", { opportunity_id });
  return data;
}
